<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <!-- 主選單 -->
            <div class="agri-result-group pwa pb-1">
                <b-container> 

                    <!-- 標題 -->
                    <PwaTitle :textTitle="group_trade.title" :showMore="group_trade.more"></PwaTitle>
                    <!-- 交易行情觀察家 -->
                    <OptionsGroup>
                        <OptionsItem classIcon="fa fa-pagelines" :textTitle='group_trade.item_vegetables.title' @clickItem="getMainCrop('蔬菜','fa-pagelines')"></OptionsItem>
                        <hr />
                        <OptionsItem classIcon="fa fa-apple"  :textTitle='group_trade.item_fruits.title' @clickItem="getMainCrop('水果','fa-apple')"></OptionsItem>
                        <hr />
                        <OptionsItem classIcon="fa fa-envira"  :textTitle='group_trade.item_grains.title' @clickItem="getMainCrop('雜糧','fa-envira')"></OptionsItem>
                    </OptionsGroup>
                    
                    <!-- 標題 -->
                    <PwaTitle :textTitle="group_weather.title" :showMore="group_weather.more"></PwaTitle>
                    <!-- 氣象觀察家 -->
                    <OptionsGroup>
                        <OptionsItem classIcon="fa fa-exclamation-triangle" :textTitle='group_weather.item_alert.title' @clickItem="getWeatherAlert()"></OptionsItem>
                        <hr />
                        <OptionsItem classIcon="fa fa-cloud"  :textTitle='group_weather.item_radar.title' @clickItem="openHref('https://www.cwa.gov.tw/V8/C/W/OBS_Radar.html')"></OptionsItem>
                        <hr />
                        <OptionsItem classIcon="fa fa-tint"  :textTitle='group_weather.item_rain.title' @clickItem="openHref('https://www.cwa.gov.tw/V8/C/P/Rainfall/Rainfall_QZJ.html')"></OptionsItem>
                        <hr />
                        <OptionsItem classIcon="fa fa-thermometer-three-quarters"  :textTitle='group_weather.item_temperature.title' @clickItem="openHref('https://www.cwa.gov.tw/V8/C/W/OBS_Temp.html')"></OptionsItem>
                    </OptionsGroup>

                    <!-- 標題 -->
                    <!-- 農地智囊 --> 
                    <PwaTitle :textTitle="group_wisdom_agri.title" :showMore="group_wisdom_agri.more" @clickMore="onSelectItem('wisdom_agri')"></PwaTitle>
                    <!-- 標題 -->
                    <!-- 查看更多 -->
                    <PwaTitle :textTitle="group_more.title" :showMore="group_more.more" @clickMore="onSelectItem('home')"></PwaTitle>
                </b-container>
            </div> 

            <!-- 彈出視窗(主產作物) -->
            <ModalWindow 
                :show="modal.main_crop.show"
                :textTitle="`
                    <i class='icon fa ${modal.main_crop.icon}'
                    aria-hidden='true'
                    style='width:30.38px; height:30.38px;font-size: 1.5rem;'>
                    </i>
                    ${modal.main_crop.title}
                `"
                :maxWidth="'720px'"
                @ClickClose="modal.main_crop.show = false;">
        
                <div class="w3-container w3-light-grey w3-round-large options-group">
                    <div v-for="(data, index) in modal.main_crop.list" :key="index">
                        <div class="options-item" @click="getMarketCrop(data.C_ID,data.C_NAME);">
                            <img class="round-image" :src="'https://agri-data.kcg.gov.tw/assets/img/main_crop_yun_lin/' + data.C_ID + '.jpg'">
                            <div class="title">{{ data.C_NAME }}</div>
                        </div>
                        <hr />
                    </div>
                </div>
            </ModalWindow>

            <!-- 彈出視窗(市場作物) -->
            <ModalWindow 
                :show="modal.market_crop.show"
                :textTitle="`
                    <img style='
                            width:32px;
                            height:32px;
                            border-radius:50%;
                            object-fit:cover;
                            vertical-align:middle;
                        '
                        src='https://agri-data.kcg.gov.tw/assets/img/main_crop_yun_lin/${modal.market_crop.select}.jpg'>
                    ${modal.market_crop.title}
                `"
                :maxWidth="'720px'"
                @ClickClose="modal.market_crop.show = false;">
        
                <div class="w3-container w3-light-grey w3-round-large options-group">
                    <div v-for="(data, index) in modal.market_crop.list" :key="index">
                        <div class="options-item" @click="getTrade(data.CROP);">
                            <div class="title">{{ data.CROP }}</div>
                        </div>
                        <hr />
                    </div>
                </div>
            </ModalWindow>

            <!-- 彈出視窗(交易行情) -->
            <ModalWindow 
                :show="modal.trade.show"
                :textTitle="modal.trade.title" 
                :maxWidth="'720px'"
                @ClickClose="modal.trade.show = false;">
        
                <div class="global-descript">交易日 : {{ modal.trade.date }} </div>
                <div class="global-descript">全台均價 : {{ modal.trade.price_avg }} 元/公斤</div>
                <div class="global-descript">全台交易量 : {{ modal.trade.volume }} 公噸</div>

                <hr />

                <!-- 表格 -->
                <table class="global-table w3-table w3-striped w3-bordered" >
                    <tr class="header table-tr">
                        <th>市場</th>
                        <th>均價</th>
                        <th>交易量</th>
                    </tr>
                    <tr class="body" v-for="(item, index) in modal.trade.list" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                        <td>{{ item.MARKET }}</td>
                        <td>{{ item.PRICE_AVG }}</td>
                        <td>{{ item.VOLUME }}</td>
                    </tr>
                </table>

                <hr />

                <!-- 表格2 -->
                <table class="global-table w3-table w3-striped w3-bordered" >
                    <tr class="header table-tr">
                        <th>市場</th>
                        <th>上價</th>
                        <th>中價</th>
                        <th>下價</th>
                    </tr>
                    <tr class="body" v-for="(item, index) in modal.trade.list" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                        <td>{{ item.MARKET }}</td>
                        <td>{{ item.PRICE_C }}</td>
                        <td>{{ item.PRICE_M }}</td>
                        <td>{{ item.PRICE_F }}</td>
                    </tr>
                </table>

                <hr />

            </ModalWindow>

            <!-- 彈出視窗(即時作物告警) -->
            <ModalWindow 
                :show="modal.weather_alert.show"
                :textTitle="modal.weather_alert.title" 
                :maxWidth="'720px'"
                @ClickClose="modal.weather_alert.show = false;">
        
                <!-- 輪播 -->
                <carousel
                    :autoplay="false" 
                    :margin="10" 
                    :loop="false" 
                    :nav="false" 
                    :dots="true" 
                    :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}" 
                    v-if="modal.weather_alert.list != null && modal.weather_alert.list.length > 0 ">

                    <div v-for="(item, index) in modal.weather_alert.list" :key="index">
                        <div class="agri-result-item drop-shadow">
                            <div class="global-title" style="padding-bottom: 10px;">{{ item.disaster }}警戒</div>
                            <div v-for="(item2, index2) in item.list" :key="index2" style="padding-bottom: 15px;">
                                <div class="global-descript">{{ item2.C_NAME }}</div>
                                <div class="global-descript">時間 : {{ formatDate(item2.TIMESTAMP) }}</div>
                                <div class="global-descript">門檻 : {{ getDescript(item2.DISASTER, item2.DURATION, item2.THRESHOLD) }}</div>
                            </div>
                            
                        </div>
                    </div>
                    
                </carousel>

            </ModalWindow>

        </div>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import OptionsGroup from '@/components/pwa/OptionsGroup.vue'
import OptionsItem from '@/components/pwa/OptionsItem.vue'
import ModalWindow from '@/components/pwa/ModalWindow.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle,
        OptionsGroup,
        OptionsItem,
        ModalWindow
    },
    data(){
        return {
            title: "小幫手",
            //群組(交易行情觀察家)
            group_trade:{
                title:"交易行情觀察家",
                more:false,
                item_vegetables:{title:"蔬菜"},
                item_fruits:{title:"水果"},
                item_grains:{title:"雜糧"},
            },
            //群組(氣象觀察家)
            group_weather:{
                title:"氣象觀察家",
                more:false,
                item_alert:{title:"查看即時作物告警"},
                item_radar:{title:"即時雷達回波圖"},
                item_rain:{title:"日累積雨量圖"},
                item_temperature:{title:"溫度分布圖"}
            },
            //群組(農地智囊)
            group_wisdom_agri:{
                title:"農地智囊",
                more:true,
            },
            //群組(查看更多)
            group_more:{
                title:"查看更多",
                more:true,
            },
            //彈出視窗
            modal:{   
                
                //主產作物
                main_crop:{

                    //是否呈現
                    show:false,
                    //目前選取的索引值
                    index:0,
                    //標題
                    title:"",
                    //目前選擇
                    select:"",
                    //圖示
                    icon:"",
                    //清單
                    list:[]
                },
                //市場作物
                market_crop:{

                    //是否呈現
                    show:false,
                    //目前選取的索引值
                    index:0,
                    //標題
                    title:"",
                    //目前選擇
                    select:"",
                    //清單
                    list:[]
                },
                //交易行情
                trade:{

                    //是否呈現
                    show:false,
                    //目前選取的索引值
                    index:0,
                    //標題
                    title:"",
                    //目前選擇
                    select:"",
                    //清單
                    list:[],
                    volume:"",
                    price_avg:"",
                },
                //即時作物告警
                weather_alert:{

                    //是否呈現
                    show:false,
                    //標題
                    title:"即時作物告警",
                    //清單
                    list:[],
                },

            },
            //api 取得主產作物(蔬菜、水果、雜糧)
            apiGetMainCrop: (data) => this.userRequest.get("https://agri-data.kcg.gov.tw/Agri_API/Api/LineMessage/MainCrop", data),    
            //api 取得市場作物
            apiGetMarketCrop: (data) => this.userRequest.get("https://agri-data.kcg.gov.tw/Agri_API/Api/LineMessage/MarketCrop?C_ID="+window.vue.modal.market_crop.select, data),    
            //api 取得交易行情
            apiGetTrade: (data) => this.userRequest.get("https://agri-data.kcg.gov.tw/Agri_API/Api/LineMessage/Trade?Crop="+window.vue.modal.trade.select, data),    
            //api 取得即時作物告警
            apiGetWeatherAlert: (data) => this.userRequest.get("https://agri-data.kcg.gov.tw/Agri_API/Api/LineMessage/WeatherAlert", data),    
        }
    },
    mounted() {

    },
    methods: {

        //開啟連結
        openHref(href){
            window.open(href, "_blank");
        },

        //取得作物預警簡述
        getDescript(DISASTER, DURATION, THRESHOLD) {
            let mDescript = "";

            if (DISASTER === "颱風") {
                mDescript = "發佈陸上颱風警報";
            }

            if (DISASTER === "焚風") {
                mDescript = "相對濕度比前一小時減少10%以上，溫度增加一度以上，且溫度>34℃，相對濕度<54%";
            }

            if (DISASTER === "高溫") {
                mDescript = `過去${DURATION}小時，平均溫度高於${THRESHOLD}℃`;
            }

            if (DISASTER === "寒害") {
                mDescript = `過去${DURATION}小時，平均溫度低於${THRESHOLD}℃`;
            }

            if (DISASTER === "降水" || DISASTER === "霪雨" || DISASTER === "梅雨") {
                mDescript = `過去${DURATION}小時，累積雨量高於${THRESHOLD}mm`;
            }

            if (DISASTER === "乾旱") {
                mDescript = `過去${parseInt(DURATION) / 24}天，累積雨量低於${THRESHOLD}mm`;
            }

            return mDescript;
        },

        //api 取得主產作物
        getMainCrop(select,icon) {
            this.enableMask();
            this.modal.main_crop.title = select;
            this.modal.main_crop.select = select;
            this.modal.main_crop.icon = icon;
            this.modal.main_crop.show = true;
            this.apiGetMainCrop({

            })
            .then((res)=>{

                //var data = JSON.parse(res.data);
                //如果直接抓高雄的資料，則無需轉成json
                const data = res.data;
                console.log(data);
                var list = [];
                switch (window.vue.modal.main_crop.select) {
                    case "蔬菜":
                        list = data.vegetables;
                    break;
                    case "水果":
                        list = data.fruits;
                    break;
                    case "雜糧":
                        list = data.grains;
                    break;
                }

                window.vue.modal.main_crop.list = [];
                window.vue.modal.main_crop.list = list;
                this.disableMask();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //api 取得市場作物
        getMarketCrop(C_ID,C_NAME) {
            this.enableMask();
            this.modal.market_crop.title = C_NAME;
            this.modal.market_crop.select = C_ID;
            this.modal.market_crop.show = true;
            this.apiGetMarketCrop({

            })
            .then((res)=>{

                const data = res.data;
                console.log(data);                
                window.vue.modal.market_crop.list = [];
                window.vue.modal.market_crop.list = data;
                this.disableMask();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //api 取得交易行情
        getTrade(select) {
            this.enableMask();
            this.modal.trade.title = select;
            this.modal.trade.select = select;
            this.modal.trade.show = true;
            this.apiGetTrade({

            })
            .then((res)=>{

                const data = res.data;
                console.log(data);                
                window.vue.modal.trade.list = [];
                window.vue.modal.trade.list = data.list;
                window.vue.modal.trade.date = "";
                if(data.list.length > 0)
                {
                    window.vue.modal.trade.date = data.list[0].T_DATE;
                }
                window.vue.modal.trade.volume = "";
                if(data.volume.length > 0)
                {
                    window.vue.modal.trade.volume = data.volume[0].VOLUME;
                }
    
                window.vue.modal.trade.price_avg = "";
                if(data.price_avg.length > 0)
                {
                    window.vue.modal.trade.price_avg = data.price_avg[0].PRICE_AVG;
                }
                this.disableMask();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //api 取得即時作物告警
        getWeatherAlert() {
            this.enableMask(); 
            this.apiGetWeatherAlert({

            })
            .then((res)=>{

                var data = res.data;
                this.modal.weather_alert.list = [];

                //測試用的
                /*
                data = [
                    {
                        "disaster": "乾旱",
                        "list": [
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            },
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶2",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            }
                        ]
                    },
                    {
                        "disaster": "乾旱222",
                        "list": [
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            },
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶2",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            },
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶3",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            },
                            {
                                "DISASTER": "乾旱",
                                "C_NAME": "茶4",
                                "THRESHOLD": 20,
                                "DURATION": 720,
                                "TIMESTAMP": "2025-11-21T08:05:00.34"
                            },
                        ]
                    }
                ];
                */
                //測試用的
                if(data.length > 0)
                {
                    console.log(data); 
                    this.modal.weather_alert.list = data;
                    this.modal.weather_alert.show = true;
                }else{
                    alert("目前雲林縣沒有任何告警。");
                }
                     
                this.disableMask();          
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //格式化時間(2025-12-01T09:05:00.69 轉成 2025-12-01 上午 09:05:00)
        formatDate(str) {
            const date = new Date(str);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");

            // 上午 / 下午判斷
            const period = hours >= 12 ? "下午" : "上午";

            // 12小時制
            hours = hours % 12;
            hours = hours === 0 ? 12 : hours; 
            hours = String(hours).padStart(2, "0");

            return `${year}-${month}-${day} ${period} ${hours}:${minutes}:${seconds}`;
        },
        //選擇選項
        onSelectItem(action) {    
      
            window.setPage(action);      
        }, 

    }
}
</script>
<style scoped>
    .round-image {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;   /* 讓圖片填滿圓形，避免變形 */
    }

    .table-tr {

        background: #1D976C;
        color: #FFFFFF;
    }

    .table-td-single {

        background: #ecfff8;
        color: #000000;
    } 

    .table-td-double {

        background: #99D0BC;
        color: #000000;
    }

</style>